<template>
  <v-flex class="cStatement" data-qa="swiftpaymentsreview-flex-0nbrv">
    <Loader v-show="loaderEnabled" zIdx="205"/>
    <div class="transferReview" data-qa="swiftpaymentsreview-div-zlvtz">
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="swiftpaymentsreview-layout-ja2glo">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="swiftpaymentsreview-flex-3c3vq">
          <v-container class="transferFunds--title-padding" data-qa="swiftpaymentsreview-container-5aa3sx">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="swiftpaymentsreview-flex-6gt5mu">
              <v-row no-gutters data-qa="swiftpaymentsreview-row-o5tj5i">
                <v-layout row wrap class="pb-2" data-qa="swiftpaymentsreview-layout-7yq69a">
                  <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="swiftpaymentsreview-flex-ajqof">
                    <v-row justify="end" data-qa="swiftpaymentsreview-row-38okv">
                      <v-avatar :tile="false" size="35" color="white" data-qa="swiftpaymentsreview-avatar-w4tejp">
                        <v-icon :color="primaryColor" data-qa="swiftpaymentsreview-icon-05k7jh">mdi-sync</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="swiftpaymentsreview-flex-1vou9r">
                    <v-row no-gutters data-qa="swiftpaymentsreview-row-hvc89u">
                      <font class="text-h5 font-weight-light white--text">
                        {{ $t("swiftPayments.title") }}</font
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>

      <v-flex
        xs12
        sm12
        md12
        lg10
        xl10
        class="pl-12 cStatement--overlayCardFlex"
       data-qa="swiftpaymentsreview-flex-8j6pd">
        <v-layout row wrap class="pl-12" data-qa="swiftpaymentsreview-layout-oxi3np">
          <v-flex xs12 sm12 md12 lg10 xl10 class="pt-4" data-qa="swiftpaymentsreview-flex-caio9h">
            <v-card data-qa="swiftpaymentsreview-card-8dnix">
              <v-card-text class="text--primary" data-qa="swiftpaymentsreview-card-text-p1ipug">
                <v-row no-gutters class="transferfunds--review-content-padding" data-qa="swiftpaymentsreview-row-ns3wt">
                  <DisplayDetails
                    :config="{
                      title: 'Summary',
                      dataList: summaryDetails,
                      translation: 'swiftPayments'
                    }"
                    class="pl-5"
                  />
                </v-row>
                <!-- DOCUMENT LIST -->
                <v-row v-if="documents.length" data-qa="swiftpaymentsreview-row-evy0al">
                  <v-container class="pl-9" data-qa="swiftpaymentsreview-container-6kjvse">
                    <div class="text-overline font-weight-bold" data-qa="swiftpaymentsreview-div-dao5vf">{{ documentsLabel }}</div>
                    <div v-for="(file, i) in documents" :key="i" :data-qa="`swiftpaymentsreview-div-v4245-${i}`">
                      <div :data-qa="`swiftpaymentsreview-div-o8sf0w-${i}`">{{ file.name }} ({{ file.displaySize }})</div>
                    </div>
                  </v-container>
                </v-row>
                <v-row
                  v-if="isFuturePayment"
                  no-gutters
                  class="px-8"
                 data-qa="swiftpaymentsreview-row-9ov3w5">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="swiftpaymentsreview-alert-lmhwj">
                    <font class="body-2 font-weight-regular">
                      {{ $t("transferfunds.scheduledPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
              </v-card-text>

              <v-card-actions class="pl-8 pt-3 pb-8" data-qa="swiftpaymentsreview-card-actions-nqv0sd">
                <v-layout wrap data-qa="swiftpaymentsreview-layout-a7atn">
                  <v-btn
                    @click="goBack"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    outlined
                    class="text-capitalize ma-2 pl-10 pr-10 py-2 px-4"
                   data-qa="swiftpaymentsreview-btn-t1tb2f">
                    {{ $t("transferfunds.backButton") }}
                  </v-btn>
                  <v-btn
                    @click="confirmTransfer"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    :width="107"
                    :height="36"
                    class="text-capitalize ma-2 pl-16 pr-16 white--text py-2 px-4"
                   data-qa="swiftpaymentsreview-btn-ryt5j">
                    {{ $t("transferfunds.confirmButton") }}
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- OTP -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        @cancel="onOtpModalClose"
        :config="modalConfig.otp"
      >
        <span slot="modalContent" data-qa="swiftpaymentsreview-span-qe6gcb">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
      <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
      <Modal
        v-if="showSuccessDialog"
        :config='getPaymentSuccessDialogConfig'
        @btn1Action="handleNewTransfer"
        @btn2Action="handleGotoDashboard"
        @btn3Action="downloadPaymentProofEnabled"
      >
      </Modal>
      <PaymentFailureDialog
        :show="failureDialog.show"
        :retry="showRetry"
        :error-list="showRetry ? failureDialog.errorList: []"
        @goBack="handleGoBack"
        @retryTransfer="handleRetryTransfer"
        @cancelTransfer="handleCancelTransfer"
      />
    </div>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import swiftPaymentTemplate from '@/plugins/swiftConfig'
import event from '@/util/event'
import preload from '@/util/preload'
import ShortUniqueId from 'short-unique-id'
import Loader from '../../../../components/common/Loader.vue'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import moment from 'moment'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

const uid = new ShortUniqueId({ length: 8 })
const uuid = new ShortUniqueId({ length: 10 })

export default {
  name: 'SwiftPaymentsReview',
  props: {
    config: {
      type: Object,
      default: undefined
    },
    display: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    DisplayDetails,
    Loader,
    PaymentFailureDialog,
    DownloadPaymentProof
  },
  data () {
    return {
      loaderEnabled: false,
      endPeriodDate: '',
      confirmAccountTransfer: true,
      successResponse: '',
      failureResponseAPI: '',
      disableBtn: false,
      summaryDetails: [],
      setOTPAuthentication: this.$appSettings.defaultConfigurations,
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPToSwiftPayment,
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      currentDate: moment().format('YYYY-MM-DD'),
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          enabled: false,
          persistent: true,
          dataListTranslation: 'swiftPayments.success',
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      swiftPaymentTemplate,
      paymentInformationId: '',
      showSuccessDialog: false,
      transferResponse: null,
      failureDialog: {
        show: false,
        errorList: [],
        retryCount: 0
      },
      showDownloadPayment: false,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  computed: {
    isFuturePayment () {
      return this.config.payload.paymentDate !== this.$formatter.formatDate(this.currentDate)
    },
    settings () {
      return {
        docCategory: this.$appSettings.defaultConfigurations.supplementaryDocuments.docCategory,
        docType: this.$appSettings.defaultConfigurations.supplementaryDocuments.docType,
        maxUploadRetryCount: this.$appSettings.defaultConfigurations.supplementaryDocuments.maxUploadRetryCount,
        required: this.$appSettings.defaultConfigurations.supplementaryDocuments.required,
        businessType: this.$appSettings.defaultConfigurations.supplementaryDocuments.SWIFT.businessType
      }
    },
    documents () {
      return this.config.payload.supplementaryDocuments
    },
    showRetry () {
      return this.failureDialog.retryCount < this.settings.maxUploadRetryCount
    },
    documentsLabel () {
      return this.settings.required ? this.$t('swiftPayments.documents') : this.$t('swiftPayments.documentsOptional')
    },
    dataList () {
      if (this.transferResponse == null) return []
      return [
        { label: 'paymentCharge', value: this.paymentCharge },
        { label: 'exchangeRate', value: this.exchangeRate },
        { label: 'dateOfExecution', value: this.dateOfExecution }
      ]
    },
    paymentCharge () {
      const { chargesApplied = null } = this.transferResponse
      return chargesApplied ? `${this.$formatter.currency.getCurrencySymbol(chargesApplied?.currency)} ${chargesApplied?.amount}` : 0
    },
    exchangeRate () {
      return this.transferResponse?.exchangeRateApplied?.baseOneRate ?? 0
    },
    dateOfExecution () {
      return this.transferResponse?.expectedExecutionDate ? this.$formatter.formatDate(this.transferResponse.expectedExecutionDate) : ''
    },
    successTitle () {
      const { transferSuccess, transferInitiated } = this.resource.success
      return this.isFuturePayment ? transferInitiated : transferSuccess
    },
    successSubtitle () {
      const { underProcessing, sameDayMessage } = this.resource.success
      return this.isFuturePayment ? underProcessing : sameDayMessage[this.transferResponse?.status]
    },
    resource () {
      return {
        yourReference: this.$t('swiftPayments.yourReference'),
        success: {
          transferSuccess: this.$t('swiftPayments.success.transferSuccess'),
          transferInitiated: this.$t('swiftPayments.success.transferInitiated'),
          underProcessing: this.$t('swiftPayments.success.underProcessing'),
          sameDayMessage: {
            ACCP: this.$t('swiftPayments.success.sameDayMessage.ACCP'),
            PDNG: this.$t('swiftPayments.success.sameDayMessage.PDNG'),
            ACSC: this.$t('swiftPayments.success.sameDayMessage.ACSC')
          },
          paymentCharge: this.$t('swiftPayments.success.paymentCharge'),
          exchangeRate: this.$t('swiftPayments.success.exchangeRate'),
          dateOfExecution: this.$t('swiftPayments.success.dateOfExecution')
        }
      }
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.successModal,
        enabled: this.showSuccessDialog,
        title: this.successTitle,
        subtitle: this.successSubtitle,
        dataDetails: this.dataList,
        body: this.$t('swiftPayments.yourReference') + ' ' + this.transferResponse?.paymentResourceId
      }
    }
  },
  created () {
    this.setSummaryData()
    event.$on('IS_OTP_VALID', (val) => {
      this.modalConfig.otp.enabled = true
      this.saveTransferData()
    })
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  methods: {
    setSummaryData () {
      this.summaryDetails = []
      this.downloadDataDetails = []
      const { payeeCountry, payeeName, ibanCheck, toAccount, bicCode, currencyType, transferAmount, chargesOptions, paymentDate, payeePostalCode, payeeTown, payeesBankCountry } = this.display.viewOnly
      this.summaryDetails.push(
        { label: 'fromLabel', value: this.config.payload.fromAccount.selectedAccountText, subValue: this.config.payload.fromAccount.selectedAccountHintText },
        { label: 'payeeName', value: payeeName },
        { label: 'payeeCountry', value: payeeCountry },
        { label: 'payeeTown', value: payeeTown },
        { label: 'payeePostalCode', value: payeePostalCode },
        { label: ibanCheck ? 'toLabelIBAN' : 'toLabel', value: toAccount },
        { label: 'bicOrswift', value: bicCode },
        { label: 'amountLabel', value: `${this.$formatter.currency.getCurrencySymbol(currencyType)} ${transferAmount}` },
        { label: 'charges', value: `${chargesOptions}` },
        { label: 'paymentDateLabel', value: paymentDate },
        { label: 'transferNote', value: this.config.payload.remarks }
      )
      this.downloadDataDetails.push(
        { label: 'fromAcc', value: this.config?.payload?.fromAccount?.selectedAccountText, subValue: this.$formatter.maskNumber(this.config?.payload?.fromAcc) },
        { label: 'payeeName', value: payeeName },
        { label: 'payeeAddress', value: `${payeeTown}, ${payeePostalCode}, ${payeeCountry}` },
        { label: 'payeeBankCountry', value: payeesBankCountry },
        { label: 'toAccIBAN', value: toAccount },
        { label: 'bicOrswift', value: bicCode },
        { label: 'amount', value: `${this.$formatter.currency.getCurrencySymbol(currencyType)} ${transferAmount}` },
        { label: 'currency', value: currencyType },
        { label: 'charges', value: `${chargesOptions}` },
        { label: 'paymentDate', value: paymentDate }
      )
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.disableBtn = false
      this.showOTPScreen = false
    },
    confirmTransfer () {
      this.disableBtn = true
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.saveTransferData()
      }
    },
    goBack () {
      event.$emit('IS_REVIEW_CLEAR', { type: 'GoBack' })
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.transferResponse?.paymentResourceId },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.transferResponse?.paymentResourceId
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
      // this.showDownloadPayment = true
    },
    async saveTransferData () {
      // this.onOtpModalClose()
      this.paymentInformationId = `DOB-${this.config.payload.currencyType}-${uuid.rnd()}`
      const userId = JSON.parse(sessionStorage.getItem('isSmeLogin'))
        ? JSON.parse(sessionStorage.getItem('corporateId'))
        : (JSON.parse(sessionStorage.getItem('customerCode')) || JSON.parse(sessionStorage.getItem('userId')))
      const { businessType, docCategory, docType } = this.settings
      const hasSupplementaryDocuments = Array.isArray(this.documents) && this.documents.length > 0
      let form
      if (hasSupplementaryDocuments) {
        form = new FormData()
        form.append('businessType', businessType)
        form.append('docCategory', docCategory)
        form.append('docType', docType)
        form.append('userId', userId)
        form.append('businessValue', this.paymentInformationId)
        this.documents.forEach(file => form.append('document', file))
      }

      await this.createFundTransfer(hasSupplementaryDocuments, form)
    },
    handleErrors (errors) {
      this.failureDialog.show = true
      this.failureDialog.errorList.push(...errors)
    },
    getChargeOption (opt) {
      const chargeOptions = {
        SHA: 'Shared',
        BEN: 'BorneByCreditor',
        OUR: 'BorneByDebtor'
      }
      return chargeOptions[opt] || ''
    },
    addUniqueItem(item) {
      const exists = this.downloadDataDetails.some(existing => existing.label === item.label);
      if (!exists) {
        this.downloadDataDetails.push(item);
      }
    },
    async createFundTransfer (hasSupplementaryDocuments, form) {
      const storeData = this.$store.getters['profileStore/profileData']
      const customerFullName = storeData.customerDetails ? storeData.customerDetails.fullName : ''

      const payload = {
        sourceId: 'DOB',
        paymentInformationId: this.paymentInformationId,
        paymentMethod: swiftPaymentTemplate.paymentMethod,
        requestedExecutionDate: this.config.payload.paymentDate.split('-').reverse().join('-'),
        paymentIdentification: {
          instructionIdentification: this.config.payload.remarks && this.config.payload.remarks.length
            ? `${this.config.payload.remarks}${uid.rnd()}` // Remarks =< 16
            : `SWIFT-${this.config.payload.currencyType}-${uid.rnd().substring(0, 6)}`,
          endToEndIdentification: this.paymentInformationId
        },
        instructionPriority: swiftPaymentTemplate.instructionPriority,
        chargeBearer: this.getChargeOption(this.config.payload.chargesOptions),
        instructedAmount: {
          amount: this.config.payload.transferAmount,
          currency: this.config.payload.currencyType
        },
        debitorAgent: {
          identification: swiftPaymentTemplate.debitorAgent.identification
        },
        debtorAccountId: {
          identificationType: this.enableIBANAccountNumberDisplay ? swiftPaymentTemplate.debtorAccountId.identificationTypeIBAN : swiftPaymentTemplate.debtorAccountId.identificationType,
          identification: this.config.payload.fromAcc,
          name: customerFullName
        },
        creditorAgent: {
          identification: this.config.payload.bicCode
        },
        creditor: {
          name: this.config.payload.payeeName,
          postalAddress: {
            country: this.config.payload.payeesBank.isocountrycode,
            townName: this.config.payload.payeeTown,
            postalCode: this.config.payload.payeePostalCode
          }
        },
        creditorAccountId: {
          identificationType: this.display.viewOnly.ibanCheck ? swiftPaymentTemplate.debtorAccountId.identificationTypeIBAN : swiftPaymentTemplate.debtorAccountId.identificationType,
          identification: this.config.payload.toAccount,
          creditorAccountName: this.config.payload.payeeName
        }
      }

      if (hasSupplementaryDocuments) {
        // payload.documentDetails = this.documents.map(file => ({ documentId: file.documentId }))
        form.append('payment-payload', JSON.stringify(payload))
      }

      const response = hasSupplementaryDocuments ? await commonService.uploadAndInitiateTransfer('swift', form) : await commonService.initiateSwiftPay(payload)
      this.transferResponse = response
      this.addUniqueItem({ label: 'exchangeRate', value: this.transferResponse?.exchangeRateApplied?.baseOneRate ?? 0 })
      if (response && !response.causes) {
        event.$emit('is_TransferComplete', true)
        this.showSuccessDialog = true
      } else {
        if (response && response.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', response)
          return
        }
        this.onOtpModalClose()
        const errors = response?.causes.map(cause => (cause.message))
        this.handleErrors(errors)
        // await deleteSupplementaryDocuments(this.documents, 'Failed SWIFT transaction')
      }
    },
    formatDisplayedToAccount (accountType) {
      const account = this.enableIBANAccountNumberDisplay
        ? this.config.payload.fromAccIban
          ? this.config.payload.fromAccIban : this.config.payload.fromAcc
        : this.config.payload.fromAcc
      let label = ''
      label = this.$t('termDepositActions.listAC.savingsLabel')
      if (accountType === 'CACC') {
        label = this.$t('termDepositActions.listAC.currentLabel')
      }
      if (accountType === 'TXSV') {
        label = this.$t('termDepositActions.listAC.cashIsaLabel')
      }
      return `${label} - ${account}`
    },
    handleNewTransfer () {
      this.showSuccessDialog = false
      this.failureDialog.retryCount = 0
      this.$emit('refreshAccounts')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    handleGotoDashboard () {
      this.showSuccessDialog = false
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      this.$router.push('/home')
    },
    handleGoBack () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.failureDialog.retryCount = 0
    },
    handleRetryTransfer () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.failureDialog.retryCount++
      // this.saveTransferData()
      this.confirmTransfer()
    },
    handleCancelTransfer () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.failureDialog.retryCount = 0
      this.$emit('refreshAccounts')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
